import React from 'react';
import { colors, type, space, radius, motion } from '../tokens';

const CATEGORIES = [
  { id: 'family',     label: 'Family',        color: colors.timeline.call },
  { id: 'household',  label: 'Household',     color: colors.brand },
  { id: 'affiliation',label: 'Affiliations',  color: colors.moves.solicit },
  { id: 'board',      label: 'Board',         color: colors.moves.cult },
  { id: 'friend',     label: 'Friends',       color: colors.textTertiary },
  { id: 'softCredit', label: 'Soft credit',   color: colors.info },
];

const RelationshipFilterBar = ({ active = null, onChange }) => {
  const allActive = active == null || active.length === CATEGORIES.length;

  const toggle = (id) => {
    if (!onChange) return;
    const current = active == null ? CATEGORIES.map(c => c.id) : active;
    if (current.includes(id)) {
      const next = current.filter(a => a !== id);
      onChange(next.length === 0 ? [] : next);
    } else {
      onChange([...current, id]);
    }
  };

  return (
    <div style={{ display: 'flex', gap: space[2], flexWrap: 'wrap', alignItems: 'center' }}>
      <button
        onClick={() => onChange && onChange(null)}
        style={{
          padding: `4px 12px`,
          background: allActive ? colors.textPrimary : colors.surface,
          color: allActive ? '#fff' : colors.textSecondary,
          border: `1px solid ${allActive ? colors.textPrimary : colors.border}`,
          borderRadius: radius.pill,
          ...type.small,
          fontWeight: 700,
          fontFamily: 'inherit',
          cursor: 'pointer',
          transition: `all ${motion.fast}`,
        }}
      >
        All
      </button>
      {CATEGORIES.map(cat => {
        const on = active ? active.includes(cat.id) : true;
        return (
          <button
            key={cat.id}
            onClick={() => toggle(cat.id)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: `4px 12px`,
              background: on ? cat.color : colors.surface,
              color: on ? '#fff' : colors.textSecondary,
              border: `1px solid ${on ? cat.color : colors.border}`,
              borderRadius: radius.pill,
              ...type.small,
              fontWeight: 700,
              fontFamily: 'inherit',
              cursor: 'pointer',
              transition: `all ${motion.fast}`,
            }}
          >
            <span style={{
              width: 8, height: 8, borderRadius: '50%',
              background: on ? '#fff' : cat.color,
            }} />
            {cat.label}
          </button>
        );
      })}
    </div>
  );
};

export default RelationshipFilterBar;
export { CATEGORIES as RELATIONSHIP_CATEGORIES };
